import { render, staticRenderFns } from "./alarmLevel.vue?vue&type=template&id=b498fba4&"
import script from "./alarmLevel.vue?vue&type=script&lang=js&"
export * from "./alarmLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports